import { ExternalIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ScheduledPostShow } from 'api/clients/ScheduledPostsClient'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { DesignChannel } from 'components/NewFileModal/Types'
import { ScheduledFlowMode } from 'components/PostPreviewModalV2/PostPreviewStore'
import { ReactNode } from 'react'
import { AlmanacFile } from 'types'

export type PostableChannelType =
  | ChannelType.FacebookPost
  | ChannelType.InstagramPosts
  | ChannelType.LinkedInPosts
  | ChannelType.Tweets

export type PostPreviewChannelType = DesignChannel | PostableChannelType

export const providerFromDesignChannelType: Partial<Record<DesignChannel, ExternalIntegrationEnum>> = {
  [DesignChannel.FacebookPost]: ExternalIntegrationEnum.Facebook,
  [DesignChannel.InstagramPost]: ExternalIntegrationEnum.Instagram,
  [DesignChannel.LinkedInPost]: ExternalIntegrationEnum.LinkedIn,
  [DesignChannel.TwitterPost]: ExternalIntegrationEnum.X,
  [DesignChannel.InstagramStory]: ExternalIntegrationEnum.Instagram,
  [DesignChannel.InstagramReel]: ExternalIntegrationEnum.Instagram,
  [DesignChannel.TikTokPost]: ExternalIntegrationEnum.TikTok,
  [DesignChannel.YoutubeShort]: ExternalIntegrationEnum.YouTube,
}

export const providerNameFromChannelType: Partial<Record<DesignChannel, string>> = {
  [DesignChannel.FacebookPost]: 'Facebook',
  [DesignChannel.InstagramPost]: 'Instagram',
  [DesignChannel.InstagramStory]: 'Instagram',
  [DesignChannel.InstagramReel]: 'Instagram',
  [DesignChannel.LinkedInPost]: 'LinkedIn',
  [DesignChannel.TwitterPost]: 'X',
  [DesignChannel.TikTokPost]: 'TikTok',
  [DesignChannel.YoutubeShort]: 'YouTube',
}

export enum PostOptionsPage {
  PostDetails = 'PostDetails',
  Schedule = 'Schedule',
  Reminder = 'Reminder',
}

export interface PostPreviewProps {
  fileId: string
  scheduledPostId: number
  channel: DesignChannel | PostableChannelType
  initialPage?: PostOptionsPage
  pollPreviewContentStream?: boolean
  showSuccessToast?: boolean
  target: 'text' | 'design'
  onFilesCreated?: (files: AlmanacFile[]) => void
  isExistingFile?: boolean
  initialFlow?: ScheduledFlowMode
  initialBrandKitId?: number
}

export interface PreviewProps {
  channel: PostPreviewChannelType
  loading: boolean
  post?: ScheduledPostShow
  integration?: ExternalIntegration
  pollPreviewContentStream?: boolean
  hideConnectButton?: boolean
  alwaysTruncateCaption?: boolean
  onEdit?: () => void
  containerClassName?: string
  photoBoxClassName?: string
  customPreviewContent?: ReactNode
  maxWidth?: number
  showVideoControls?: boolean
  isActive?: boolean
  isDesignBlank?: boolean
  isInsertingMedia?: boolean
  isTransitioning?: boolean
  isGenerating?: boolean
  showHoverActionOverlay?: boolean
  almanacFileKey?: string
  onClose?: () => void
}
